import { render, staticRenderFns } from "./SassConfig.vue?vue&type=template&id=6ba33e2e&scoped=true"
import script from "./SassConfig.vue?vue&type=script&lang=js"
export * from "./SassConfig.vue?vue&type=script&lang=js"
import style0 from "./SassConfig.vue?vue&type=style&index=0&id=6ba33e2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba33e2e",
  null
  
)

export default component.exports